module.exports = __webpack_public_path__ + "static/media/rdn.04580a6c.svg";